import React from 'react'
import './Message.css'

const Message = ({ children, type = 'notification' }) => (
    <div className={`message message--${type}`}>
        {children}
    </div>
)

export default Message



// WEBPACK FOOTER //
// ./src/components/Message/Message.js